var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgButtonUpload = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 15.5 19.5"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.75 0h-10A2.75 2.75 0 000 2.75v14a2.75 2.75 0 002.75 2.75h10a2.75 2.75 0 002.75-2.75v-14A2.75 2.75 0 0012.75 0zM14 16.75A1.25 1.25 0 0112.75 18h-10a1.25 1.25 0 01-1.25-1.25v-14A1.25 1.25 0 012.75 1.5h10A1.25 1.25 0 0114 2.75z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.29 6.89a.7.7 0 00-.54-.21.7.7 0 00-.54.21L4.43 9.67a.75.75 0 000 1.06A.79.79 0 005 11a.75.75 0 00.53-.22L7 9.23v4.89a.75.75 0 001.5 0V9.21l1.5 1.52a.75.75 0 00.53.22.79.79 0 00.53-.22.75.75 0 000-1.06z"
})))));

export default SvgButtonUpload;